import { FIELD_VALUES } from './fieldValues';
import { LIABILITY_TYPE } from './liability';

export enum CREDIT_REPORT_RESPONDS_CODE {
  CR_SUCCESS = 'CR_SUCCESS',
  RD_FETCH_FAILED = 'Required documents fetch failed',
  CR_FETCH_FAILED = 'CreditReport fetch failed',
  CR_PDF_FETCH_FAILED = 'CreditReport PDF fetch failed',
  NO_MATCH = 'CR_NO_MATCH',
  IN_PROGRESS = 'CR_IN_PROGRESS',
}

export enum CREDIT_REPORT_DOCUMENTS_STATUS {
  COMPLETE = 'Complete',
  INCOMPLETE = 'Incomplete',
}

export const CR_ACCOUNTS_AND_ENQUIRIES_TOOLTIP_TEXT =
  'Details about accounts the applicant holds, and the number of credit enquiries or applications made.';
export const CR_DEFAULTS_TOOLTIP_TEXT =
  'Debt of $150 or more that were not paid within 60 days and have been listed by a credit provider.';
export const CR_INSOLVENCIES_AND_ACTIONS_TOOLTIP_TEXT =
  'This includes bankruptcy, debt agreements and other personal insolvency agreements.';
export const CR_DIRECTORSHIPS_TOOLTIP_TEXT = 'Any proprietorships or directorships the applicant has.';

export enum CREDIT_REPORT_REPAYMENT_STATUS {
  NOT_OVERDUE = 'Not Overdue',
  OVERDUE_1_MONTH = 'Overdue Upto 29 Days',
  OVERDUE_2_MONTH = 'Overdue Upto 59 Days',
  OVERDUE_3_MONTH = 'Overdue Upto 89 Days',
  OVERDUE_4_MONTH = 'Overdue Upto 119 Days',
  OVERDUE_5_MONTH = 'Overdue Upto 149 Days',
  OVERDUE_6_MONTH = 'Overdue Upto 179 Days',
}

export enum IDENTIFICATION_DOCUMENT_TYPE {
  AUSTRALIAN_DRIVER_LICENSE = 'australian_driver_license',
  NATIONAL_ID_CARD = 'national_id_card',
  PASSPORT = 'passport',
}

export enum CREDIT_REPORT_ACCOUNT_TYPE_CODE {
  CreditCard = 'CC',
  ChargeCard = 'CA',
  RealPropertyMortgage = 'RM',
  PersonalLoanFixedTerm = 'PF',
  PersonalLoanRevolving = 'PR',
  Overdraft = 'OD',
  AutoLoan = 'AL',
  EquipmentHireOrRental = 'RE',
  BuyNowPayLaterFacility = 'BF',
  BuyNowPayLaterTransaction = 'BT',
}

interface CreditReportAccountTypeLabels {
  [key: string]: string;
}

export const CREDIT_REPORT_ACCOUNT_TYPE_LABELS: CreditReportAccountTypeLabels = {
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.CreditCard]: 'Credit Card',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.ChargeCard]: 'Credit Card',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.RealPropertyMortgage]: 'Home Loan',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.PersonalLoanFixedTerm]: 'Personal Loan',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.PersonalLoanRevolving]: 'Overdraft',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.Overdraft]: 'Overdraft',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.AutoLoan]: 'Car Loan',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.EquipmentHireOrRental]: 'Lease',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.BuyNowPayLaterFacility]: 'BNPL',
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.BuyNowPayLaterTransaction]: 'BNPL',
};

interface CreditReportAccountTypeToPlatformMapping {
  [key: string]: string;
}
export const CREDIT_REPORT_ACCOUNT_TYPE_TO_PLATFORM_MAPPING: CreditReportAccountTypeToPlatformMapping = {
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.CreditCard]: LIABILITY_TYPE.CREDIT_CARD,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.ChargeCard]: LIABILITY_TYPE.CREDIT_CARD,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.RealPropertyMortgage]: LIABILITY_TYPE.HOME_LOAN,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.PersonalLoanFixedTerm]: FIELD_VALUES.PERSONAL_LOAN,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.PersonalLoanRevolving]: FIELD_VALUES.OVERDRAFT,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.Overdraft]: FIELD_VALUES.OVERDRAFT,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.AutoLoan]: FIELD_VALUES.CAR_LOAN,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.EquipmentHireOrRental]: LIABILITY_TYPE.LEASE,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.BuyNowPayLaterFacility]: FIELD_VALUES.OTHER,
  [CREDIT_REPORT_ACCOUNT_TYPE_CODE.BuyNowPayLaterTransaction]: FIELD_VALUES.OTHER,
};
